import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
let sceneChangeListenerId = -1;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_register() {
  LwAPI?.registerOnSceneChange(sceneChangeHandler).then(function (listenerId) {
    sceneChangeListenerId = listenerId;
    (document.getElementById("output") as HTMLTextAreaElement).value =
      "Scene change listener registered";
  });
}

function ex_unregister() {
  if (sceneChangeListenerId != -1) {
    LwAPI?.unregisterOnSceneChange(sceneChangeListenerId);
    sceneChangeListenerId = -1;
    (document.getElementById("output") as HTMLTextAreaElement).value =
      "Scene change listener unregistered";
  }
}

function sceneChangeHandler() {
  LwAPI?.getCaptureWithPoints().then(function (result) {
    (document.getElementById("output") as HTMLTextAreaElement).value =
      "Current view parameters:\r\n" + JSON.stringify(result.camera, null, " ");
  });
}

// Bind functions to buttons
document.getElementById("reg")?.addEventListener("click", async () => {
  await apiReady;
  ex_register();
});
document.getElementById("unreg")?.addEventListener("click", async () => {
  await apiReady;
  ex_unregister();
});
